module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-45.21bdadbc.png";